import React from "react";
import {
  Avatar,
  Box,
  Button,
  Skeleton,
  Typography,
} from "@mui/material";
import PdfViewerModal from "./PdfViewerModal";

export default function AssessmentsList({
  filteredStudentGoals,
  isLoadingGoalData,
  selectedGoals,
  onViewGoal,
  onSelectGoal,
  selectedAssessmentType,
  pdfModalOpen,
  pdfUrl,
  setPdfModalOpen,
}) {
  if (isLoadingGoalData) {
    return (
      <Box>
        <Box
          sx={{
            maxHeight: "400px", // Height for approximately 5 items
            overflowY: "auto",
            pr: 1, // Add padding for scrollbar
          }}
        >
          {[...Array(5)].map((_, idx) => (
            <Box
              key={idx}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              bgcolor="#f3f4f6"
              borderRadius={2}
              px={2}
              py={1.5}
              mb={1}
            >
              <Box display="flex" alignItems="center">
                <Skeleton
                  variant="circular"
                  width={40}
                  height={40}
                  sx={{ mr: 2 }}
                />
                <Skeleton variant="text" width={120} height={20} />
              </Box>
              <Box display="flex" gap={1}>
                <Skeleton variant="rectangular" width={60} height={30} />
                <Skeleton variant="rectangular" width={80} height={30} />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    );
  }

  if (!filteredStudentGoals?.length) {
    return (
      <Box p={2}>
        <Typography variant="body1" color="text.secondary">
          {selectedAssessmentType === "Vineland Assessment"
            ? "No Assessments available."
            : selectedAssessmentType === "others"
            ? "No Assessments available."
            : "No Assessments available."}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          maxHeight: "400px",
          overflowY: "auto",
          pr: 1,
        }}
      >
        {filteredStudentGoals.map((student, sIndex) => {
          const attachments = student.attachmentData || [];

          return attachments.map((attachment, aIndex) => {
            const doc = attachment.docData;
            const assessmentType = doc?.typeOfAssessment || "Unknown";
            const summaryLine = doc?.notes || "No summary available";
            const createdAt = doc?.createdAt?._seconds
              ? new Date(doc.createdAt._seconds * 1000).toLocaleDateString()
              : "";

            const docId = attachment.docId;

            return (
              <Box
                key={docId}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                bgcolor="#eef0ff"
                border="1px solid #dcdcdc"
                borderRadius={2}
                px={2}
                py={1.5}
                mb={1}
              >
                {/* LEFT: Avatar + one-line info */}
                <Box display="flex" alignItems="center">
                  <Avatar
                    sx={{
                      mr: 2,
                      backgroundColor: "#cdd1ff",
                      color: "black",
                    }}
                  >
                    {assessmentType?.[0]?.toUpperCase()}
                  </Avatar>

                  <Box>
                    {/* Title */}
                    <Typography variant="body1" fontWeight="medium">
                      {assessmentType}
                    </Typography>

                    {/* One-line description with date */}
                    <Typography variant="body2" color="text.secondary">
                      {summaryLine} • {createdAt}
                    </Typography>
                  </Box>
                </Box>

                {/* RIGHT: Buttons */}
                <Box display="flex" gap={1}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => onViewGoal(doc)}
                  >
                    View
                  </Button>

                  <Button
                    variant={
                      selectedGoals.includes(docId) ? "contained" : "outlined"
                    }
                    size="small"
                    onClick={() => onSelectGoal({ ...doc, id: docId })}
                    sx={{
                      textTransform: "none",
                      backgroundColor: selectedGoals.includes(docId)
                        ? "#7b7add"
                        : "transparent",
                      color: selectedGoals.includes(docId)
                        ? "white"
                        : "#9291ef",
                      "&:hover": {
                        backgroundColor: selectedGoals.includes(docId)
                          ? "#6a69d9"
                          : "#f0f0ff",
                      },
                    }}
                  >
                    {selectedGoals.includes(docId) ? "Selected" : "Select"}
                  </Button>
                </Box>
              </Box>
            );
          });
        })}
      </Box>
      <PdfViewerModal
        open={pdfModalOpen}
        onClose={() => setPdfModalOpen(false)}
        pdfUrl={pdfUrl}
      />
    </Box>
  );
}
